import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

import { ChannelIcon } from '@/components/channels/ChannelIcon';
import { useShopPath } from '@/hooks/useShopPath';

/**
 * Top strip of every per-channel block on the Results page: the unify
 * ChannelIcon + name + one-line sub + a pill linking to the channel's manage
 * page. The icon and the manage-page link mirror what's used on the channels
 * grid so the navigation feels continuous.
 */
export function ChannelSectionHeader({ channel, sub }) {
	const { shopPath } = useShopPath();
	return (
		<div className="flex items-center gap-4">
			<ChannelIcon channelId={channel.id} src={channel.iconUrl} className="h-14 w-14 shrink-0" />
			<div className="min-w-0 flex-1">
				<h2 className="truncate text-xl font-extrabold tracking-tight text-foreground md:text-[22px]">{channel.title}</h2>
				<p className="mt-1 truncate text-sm text-muted-foreground">{sub}</p>
			</div>
			<Link
				to={shopPath(`/channels/${channel.id}/manage`)}
				className="inline-flex shrink-0 items-center gap-1.5 rounded-full border border-border bg-background px-4 py-2 text-sm font-semibold text-foreground transition hover:bg-muted/50"
			>
				Manage channel <ChevronRight className="h-4 w-4" />
			</Link>
		</div>
	);
}
